<script>
	export default {
		props: {
			data: {
				type: Object,
				required: true
			},
			errorForm: {
				type: Boolean,
				required: true
			}
		},	
		watch: {
			"data.value": {
				handler(value) {
					if(value) this.data.error = false;
					else this.data.error = true;
				},
				deep: true,
			}
		}
	}
</script>

<template>
	<div>
		<label class="form-label text-secondary">
			{{ data.label }}
		</label>
		<input
			v-model="data.value"
			type="text"
			autocomplete="off"
			class="form-control input-custom"
			:class="{'is-invalid': data.error  && errorForm }"
			placeholder="Ingresa la información"
		/>
		<div class="invalid-feedback">
			Debes agregar la información.
		</div>
	</div>
</template>